module.exports = __webpack_public_path__ + "static/media/strengthDetailTitle.0e0ba570.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/strengthDetailTitle.png
// module id = 1504
// module chunks = 0